import React from "react";
import Form from "react-bootstrap/Form";
import InputField from "components/fields/InputField";
import ImageUploadView from "components/fields/ImageUploadView";

import {
  Field,
  Fieldset,
  Input,
  Label,
  Legend,
  Select,
  Textarea,
  Button,
} from "@headlessui/react";

export function Edit({ initData, onSave, validation }) {
  //  let [errors, setErrors] = React.useState()
  //  let [saving, setSaving] = React.useState(false)
  //  let [name, setName] = React.useState(initialName);
  let [data, setData] = React.useState(initData);
  /*
const [data, setData] = React.useReducer(
  (state, newState) => {
	console.log( state );
	console.log( newState );
	return { ...state, ...newState };
},
  initData
);
*/

  const handleOnChange = (event) => {
    let name, value;
    if (event.target) {
      name = event.target.name;
      value = event.target.value;
    } else {
      //		name = event.name;
      //		value = event.value;
    }
    initData[name] = value;
    setData((prevState) => ({ name, value }));

    //	this.setState({user: initData});

    if (validation[name]) {
      validation[name] = null;
    }
  };

  const onSaveWrapped = (event) => {
    event.preventDefault();
    onSave(initData);
  };

  const [key, setKey] = React.useState("naw");
  return (
    <>
      <div className="mb-4 md:flex md:items-center md:justify-between">
        <div className="flex-1 min-w-0">
          <h2 className="font-bold text-gray-900 max-md:mb-3 text-2xl/7 sm:truncate sm:text-3xl sm:tracking-tight">
            Mijn profiel
          </h2>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-x-8 gap-y-10 py-16 max-w-7xl md:grid-cols-3">
        <div>
          <h3 className="font-semibold text-gray-900 text-base/7">
            Persoonlijke gegevens
          </h3>
          <p className="mt-1 max-w-2xl text-gray-500 text-sm/6">
            De accountnaam is de naam die op Circfy word getoond
          </p>
        </div>
        <Form className="space-y-6 md:col-span-2" onSubmit={onSaveWrapped}>
          <ImageUploadView
            name="image"
            lbl="Upload hier uw profiel foto"
            image={initData.image}
            onChange={handleOnChange}
          />
          <InputField
            lbl="Weergave naam"
            placeholder=""
            name="firstname"
            validation={validation}
            value={initData}
            onChange={handleOnChange}
          />
          <InputField
            lbl="Telefoonnummer"
            placeholder=""
            name="phone1"
            validation={validation}
            value={initData}
            onChange={handleOnChange}
            extraClass="col-md-6 mb-3"
          />
          <InputField
            lbl="E-mail (login)"
            name="email"
            validation={validation}
            value={initData}
            onChange={handleOnChange}
          />

          <Button type="submit" className="save-button left btn-primary">
            Opslaan
          </Button>
        </Form>
      </div>
    </>
  );
}
